import { Component, HostListener } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedData } from '../shared/sharedData';
import { Configuration } from '../shared/services/configuration';
import { HttpClientCustom } from '../shared/services/http.client';
import * as _ from 'underscore';
import { Auth } from '../shared/services/auth';
import { ToasterComponent } from '../toasterComponent/toasterComponent';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'Confirmation',
    templateUrl: 'confirmation.html'
})
export class ConfirmationComponent {
    public confirmationMessage: any;
    public employeeCodes: any = [];
    public program: any;
    public type: any;
    public _baseUrl: any;
    public id: any;
    public forceResign: any = false;
    public bulkResign: any = false;
    public ccConversion: boolean = false;
    public disabledButton: any = false;
    public ccDate: any;
    public maxDate = { year: null, month: null, day: null };
    public minDate = { year: null, month: null, day: null };
    public dynamicId: any;

    constructor(
        public route: ActivatedRoute,
        public activeModal: NgbActiveModal,
        public _global: Configuration,
        public http: HttpClientCustom,
        public _auth: Auth,
        public share: SharedData,
        public _toaster: ToasterComponent,
        public translate: TranslateService
    ) {
        this.translate.get('areYouSure').subscribe((msg) => {
            this.confirmationMessage = msg;
        });

        let data: any = this.share.getData();
        this.type = data.type;
        this.id = data.program;
        this._baseUrl = _global.get("EPMS_BASE_URL");
        if (this.type == 'Stop') {
            this.program = data.program;
            this.translate.get('areYouSureYouWantToStopTheProgram', { programName: this.program.name }).subscribe((msg) => {
                this.confirmationMessage = msg;
            });

        }
        if (this.type == 'Force_close') {
            this.translate.get('sureWantToForceClose').subscribe((msg) => {
                this.confirmationMessage = msg;
            });
        }
        if (this.type == 'logOut') {
            this.translate.get('sureWantToLogOut').subscribe((msg) => {
                this.confirmationMessage = msg;
            });
        }
        if (this.type == 'Resign') {
            this.translate.get('sureWantToResign').subscribe((msg) => {
                this.confirmationMessage = msg;
            });
        }
        if (this.type == 'ResetDay0') {
            this.id = data.employeeId;
            this.translate.get('sureWantToResetDay0').subscribe((msg) => {
                this.confirmationMessage = msg;
            });
        }
        if (this.type == 'ReloadEmp') {
            this.translate.get('sureWantToReloadEmployee').subscribe((msg) => {
                this.confirmationMessage = msg;
            });
        }
        if (this.type == 'addLocationAssessment') {
            this.id = data.employeeId;
            this.translate.get('sureWantToAddLocationAssessment').subscribe((msg) => {
                this.confirmationMessage = msg;
            });
        }
        if (this.type == 'convertToLowRisk') {
            this.id = data.employeeId;
            this.translate.get('sureWantToConvertToLowRisk').subscribe((msg) => {
                this.confirmationMessage = msg;
            });
        }
        if (this.type == 'resolveCertErrors') {
            this.id = data.employeeId;
            this.translate.get('sureWantToResolve').subscribe((msg) => {
                this.confirmationMessage = msg;
            });
        }
        if (this.type == 'convertToConfirmedCase') {
            let today = new Date();
            let dd = today.getDate();
            let mm = today.getMonth() + 1; // January is 0!
            let yyyy = today.getFullYear();
            this.maxDate.day = dd;
            this.maxDate.month = mm;
            this.maxDate.year = yyyy;
            let prior = new Date(new Date().getTime() - (9 * 24 * 60 * 60 * 1000));
            let dd1 = prior.getDate();
            let mm1 = prior.getMonth() + 1; // January is 0!
            let yyyy1 = prior.getFullYear();
            this.minDate.day = dd1;
            this.minDate.month = mm1;
            this.minDate.year = yyyy1;
            this.ccConversion = true;
            this.id = data.employeeId;
            this.translate.get('sureWantToConvertToConfirmedCase').subscribe((msg) => {
                this.confirmationMessage = msg;
            });
        }
        if (this.type == 'revertICVerification') {
            this.id = data.employeeId;
            this.translate.get('sureWantToRevertICVerification').subscribe((msg) => {
                this.confirmationMessage = msg;
            });
        }
        if (this.type == 'revertNonVaccineAccount') {
            this.id = data.employeeId;
            this.confirmationMessage = "Are you sure you want to revert Non vaccination account";
        }
        if (this.type == 'addMentalAssessment') {
            this.id = data.employeeId;
            this.translate.get('sureWantToAddMentalAssessment').subscribe((msg) => {
                this.confirmationMessage = msg;
            });
        }
        if (this.type == 'Bulk_Resign') {
            this.bulkResign = true;
            this.forceResign = true;
            this.translate.get('Sure WantTo do Bulk  Resign').subscribe((msg) => {
                this.confirmationMessage = msg;
            });
        }
        if (this.type == 'Delete') {
            this.translate.get('sureWantToDelete').subscribe((msg) => {
                this.confirmationMessage = msg;
            });
        }
        if (this.type == 'publish_score') {
            this.translate.get('sureWantToPublishScore').subscribe((msg) => {
                this.confirmationMessage = msg;
            });
        }
        if (this.type == 'publishStartegy') {
            this.translate.get('sureWantToPublishStrategy').subscribe((msg) => {
                this.confirmationMessage = msg;
            });
        }
        if (this.type == 'deleteStartegy') {
            this.translate.get('sureWantToDelete').subscribe((msg) => {
                this.confirmationMessage = msg;
            });
        }
        if (this.type == 'announcement') {
            this.translate.get('areYouSureYouWantToAnnouncementEmployees').subscribe((msg) => {
                this.confirmationMessage = msg;
            });
        }

        if (this.type == 'sendBulkInvitation') {
            this.translate.get('areYouSureYouWantToSendBulKInvitation').subscribe((msg) => {
                this.confirmationMessage = msg;
            });
        }
    }
    confirm() {
        if (this.type == 'Resign') {
            this.actionResignConfirmed();
        } else if (this.type == 'ResetDay0') {
            this.resetDay0Assessment();
        } else if (this.type == 'addLocationAssessment') {
            this.addLocationAssessment();
        } else if (this.type == 'convertToLowRisk') {
            this.convertToLowRisk();
        } else if (this.type == 'convertToConfirmedCase') {
            console.log(this.ccDate.sampleReceivedDate);
            this.convertToConfirmedCase();
        } else if (this.type == 'revertICVerification') {
            this.revertICVerification();
        } else if (this.type == 'revertNonVaccineAccount') {
            this.revertNonVaccineAccount();
        } else if (this.type == 'addMentalAssessment') {
            this.addMentalAssessment();
        } else if (this.type == 'ReloadEmp') {
            this.reloadEmployee();
        } else if (this.type == 'resolveCertErrors') {
            this.resolveCertErrors();
        } else if (this.type == 'Delete') {
            this.actionDeleteConfirmed();
        } else if (this.type == 'changeRole') {
            this.changeRoleConfirmed();
        } else if (this.type == 'removeLabTest') {
            this.removeLabTest();
        } else if (this.type == 'removeHSOBadge') {
            this.removeHSOBadge();
        } else {
            this.activeModal.close('confirmed');
        }



    }
    forceResignConfirmed() {
        this.activeModal.close('forceResign');
    }
    resetDay0Assessment() {
        let that = this;
        let url = that._baseUrl + "v1/webAdmin/assessment/resetEmployeeToDay0ByAdmin/" + that.id;
        that.http.get(url).subscribe((result) => {
            if (result) {
                setTimeout(() => { that.activeModal.close('confirmed'); }, 1000);
                that.translate.get('employeeReset').subscribe((msg) => {
                    that._toaster.showSuccess(msg);
                });
            }
        });
    }
    addLocationAssessment() {
        let that = this;
        let url = that._baseUrl + "v1/webAdmin/assessment/addLocationAssessment/" + that.id;
        that.http.get(url).subscribe((result) => {
            if (result) {
                setTimeout(() => { that.activeModal.close('confirmed'); }, 1000);
                that.translate.get('locAssessmentSuccess').subscribe((msg) => {
                    that._toaster.showSuccess(msg);
                });
            }
        });
    }

    convertToLowRisk() {
        let that = this;
        let url = that._baseUrl + "v1/webAdmin/assessment/markAsLowRisk/" + that.id;
        that.http.get(url).subscribe((result) => {
            if (result) {
                setTimeout(() => { that.activeModal.close('confirmed'); }, 1000);
                that.translate.get('lRSuccess').subscribe((msg) => {
                    that._toaster.showSuccess(msg);
                });
            }
        });
    }

    resolveCertErrors() {
        let that = this;
        let url = that._baseUrl + "v1/webAdmin/employee/resolveCertError/" + that.id;
        that.http.get(url).subscribe((result) => {
            if (result) {
                setTimeout(() => { that.activeModal.close('confirmed'); }, 1000);
                that.translate.get('resolveSuccess').subscribe((msg) => {
                    that._toaster.showSuccess(msg);
                });
            }
        });
    }
    convertToConfirmedCase() {
        let that = this;
        let url = that._baseUrl + "v1/webAdmin/assessment/markAsConfirmedCase/" + that.id;
        let payload = { id: this.ccDate.sampleReceivedDate };
        that.http.post(url, payload).subscribe((result) => {
            if (result != null && result.status == "SUCCESS") {
                setTimeout(() => { that.activeModal.close('confirmed'); }, 1000);
                that.translate.get('confirmedCaseSuccess').subscribe((msg) => {
                    that._toaster.showSuccess(msg);
                });
            } else {
                setTimeout(() => { that.activeModal.close('confirmed'); }, 1000);
                that.translate.get('confirmedCaseFailed').subscribe((msg) => {
                    that._toaster.showError(msg);
                });
            }
        });
    }
    revertICVerification() {
        let that = this;
        let url = that._baseUrl + "v1/webAdmin/assessment/revertICVerification/" + that.id;
        that.http.get(url).subscribe((result) => {
            if (result) {
                setTimeout(() => { that.activeModal.close('confirmed'); }, 1000);
                that.translate.get('revertICSuccess').subscribe((msg) => {
                    that._toaster.showSuccess(msg);
                });
            }
        });
    }

    revertNonVaccineAccount() {
        let that = this;
        let url = that._baseUrl + "v1/webAdmin/assessment/revertNonVaccineAccount/" + that.id;
        that.http.get(url).subscribe((result) => {
            if (result) {
                setTimeout(() => { that.activeModal.close('confirmed'); }, 1000);
                that.translate.get('empUpdated').subscribe((msg) => {
                    that._toaster.showSuccess(msg);
                });
            }
        });
    }

    addMentalAssessment() {
        let that = this;
        let url = that._baseUrl + "v1/webAdmin/assessment/addMentalAssessment/" + that.id;
        that.http.get(url).subscribe((result) => {
            if (result) {
                setTimeout(() => { that.activeModal.close('confirmed'); }, 1000);
                that.translate.get('mhAssessmentSuccess').subscribe((msg) => {
                    that._toaster.showSuccess(msg);
                });
            }
        });
    }
    reloadEmployee() {
        let that = this;
        let sd: any = this.share.getData();
        let url = that._baseUrl + "v1/webAdmin/employee/reloadEmployee/" + sd.employeeId;
        that.http.get(url).subscribe((result) => {
            if (result) {
                setTimeout(() => { that.activeModal.close('confirmed'); }, 1000);
                that.translate.get('reloadEmployeeSuccess').subscribe((msg) => {
                    that._toaster.showSuccess(msg);
                });
            }
        });
    }
    actionResignConfirmed() {
        if (this.type == 'Bulk_Resign') {
            this.activeModal.close('not_confirmed');
        } else {
            try {
                let that = this;
                let errors: any;
                let payload = {
                    employeeIds: [that.id],
                    forceResign: that.forceResign
                };
                if (that.forceResign) {
                    that.disabledButton = true;
                }
                let url = that._baseUrl + "v1/webAdmin/employee/resignEmployees";
                that.http.post(url, payload).subscribe((result) => {
                    if (result.success == false) {
                        _.each(result.errorMessages, function (value) {
                            that.translate.get('wantToContinue', { key: value }).subscribe((msg) => {
                                that.confirmationMessage = msg;
                            });
                            that.forceResign = true;
                        });
                    } else {
                        setTimeout(() => { that.activeModal.close('confirmed'); }, 1000);
                        that.translate.get('employeeResigned').subscribe((msg) => {
                            that._toaster.showSuccess(msg);
                        });
                    }
                });
            } catch (e) {
                console.log("saveEmployee error caught", e);
            }
        }
    }

    //date format in string
    public onDateChange(e) {
        if (e.day < 10) {
            if (e.month < 10) {
                this.ccDate.sampleReceivedDate = e.year + '-0' + e.month + '-0' + e.day;
            } else {
                this.ccDate.sampleReceivedDate = e.year + '-' + e.month + '-0' + e.day;
            }
        } else {
            if (e.month < 10) {
                this.ccDate.sampleReceivedDate = e.year + '-0' + e.month + '-' + e.day;
            } else {
                this.ccDate.sampleReceivedDate = e.year + '-' + e.month + '-' + e.day;
            }
        }
    }

    // temporary fixes for cal close
    public openDatePicker(id) {
        this.dynamicId = id;
    }

    // temporary fixes for cal close
    @HostListener('document:click', ['$event', '$event.target'])
    public onClick(event: MouseEvent, targetElement: HTMLElement) {
        if (!(targetElement.tagName === 'BUTTON'
            || targetElement.tagName === 'I' || targetElement.tagName === 'SELECT'
            || targetElement.tagName === 'SPAN')) {
            let self = this;
            if (self.dynamicId) {
                if (self.dynamicId.isOpen()) {
                    setTimeout(function () {
                        this.trackHides = null;
                    }, 10);
                }
            }
        }
    }

    changeRoleConfirmed() {
        try {
            let sd: any = this.share.getData();
            let _self = this;
            _self.disabledButton = true;

            let url = _self._baseUrl + "v1/webAdmin/role/changeRoleByEmpId/" + sd.employeeId + "/role/" + sd.data;
            _self.http.post(url, {}).subscribe((result) => {
                setTimeout(() => { _self.activeModal.close('confirmed'); }, 1000);
                if (result.success == true) {
                    _self._toaster.showSuccess('Employee role changed successfully');
                }
            });
        } catch (e) {
            console.log("change employee role error caught", e);
        }
    }

    removeLabTest() {
        try {
            let sd: any = this.share.getData();
            let _self = this;
            _self.disabledButton = true;

            let url = _self._baseUrl + "v1/webAdmin/employee/clearLabTestResultsByIC";
            _self.http.post(url, { id: sd.data }).subscribe((result) => {
                setTimeout(() => { _self.activeModal.close('confirmed'); }, 1000);
                if (result.success == true) {
                    _self._toaster.showSuccess('Lab test result removed from profile');
                }
            });
        } catch (e) {
            console.log("change employee role error caught", e);
        }
    }

    removeHSOBadge() {
        try {
            let sd: any = this.share.getData();
            let _self = this;
            _self.disabledButton = true;

            let url = _self._baseUrl + "v1/webAdmin/employee/removeHSOBadge";
            _self.http.post(url, { id: sd.data }).subscribe((result) => {
                setTimeout(() => { _self.activeModal.close('confirmed'); }, 1000);
                if (result.success == true) {
                    _self._toaster.showSuccess('HSO badge removed from profile');
                }
            });
        } catch (e) {
            console.log("change employee role error caught", e);
        }
    }

    actionDeleteConfirmed() {
        try {
            let that = this;
            that.disabledButton = true;

            let url = that._baseUrl + "v1/webAdmin/employee/deactivateAccount?username=" + that.id;
            that.http.get(url).subscribe((result) => {
                if (result.success == false) {
                    _.each(result.errorMessages, function (value) {
                        that.translate.get('wantToContinue', { key: value }).subscribe((msg) => {
                            that.confirmationMessage = msg;
                        });
                        that.forceResign = true;
                    });
                } else {
                    setTimeout(() => { that.activeModal.close('confirmed'); }, 1000);
                    that.translate.get('employeeDeleted').subscribe((msg) => {
                        that._toaster.showSuccess(msg);
                    });
                }
            });
        } catch (e) {
            console.log("Delete employee error caught", e);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/confirmation/confirmation.ts